module.exports = __webpack_public_path__ + "img/logo.ae8676b1.svg";